import AddressForm from 'components/AddressForm/AddressFormComponent';
import AddressFormContainer from 'components/AddressForm/AddressFormContainer';

export { default as AddressForm } from 'components/AddressForm/AddressFormComponent';
export { default as AddressFormContainer } from 'components/AddressForm/AddressFormContainer';

export default {
  AddressForm,
  AddressFormContainer,
};
